import { action } from 'easy-peasy';
import { IActionFinishCrisisVisit } from '../types';
import { matchesAllocation, recalculateCrisisStatus } from './helpers';

const finishCrisisVisit: IActionFinishCrisisVisit = action(
  (state, { userId, clientId, crisisCallId, isCanceled, otherVisitsExist }) => {
    if (!crisisCallId) {
      // Ad-hoc visit (no allocation): only clear the team member flag
      const teamMember = state.crisisCallTeamMembers.find(member => member.id === userId);

      if (!teamMember) {
        return;
      }

      teamMember.hasNoAllocationActiveVisit = false;
      recalculateCrisisStatus(teamMember);
      return;
    }

    const isCanceledForOne = isCanceled && otherVisitsExist === true;

    if (isCanceledForOne && !userId) {
      return;
    }

    const teamMembers = isCanceledForOne
      ? state.crisisCallTeamMembers.filter(member => member.id === userId)
      : state.crisisCallTeamMembers;

    teamMembers.forEach(teamMember => {
      let wasUpdated = false;

      if (isCanceled) {
        teamMember.allocatedClients.forEach(allocation => {
          if (matchesAllocation(allocation, clientId, crisisCallId)) {
            allocation.visitStartTime = '';
            wasUpdated = true;
          }
        });
      } else {
        const nextAllocatedClients = teamMember.allocatedClients.filter(allocation => {
          const shouldRemove = matchesAllocation(allocation, clientId, crisisCallId);

          if (shouldRemove) {
            wasUpdated = true;
          }

          return !shouldRemove;
        });

        teamMember.allocatedClients = nextAllocatedClients;
      }

      if (wasUpdated) {
        recalculateCrisisStatus(teamMember);
      }
    });
  },
);

export default finishCrisisVisit;
